<template>
  <div class="reportRecord">
    <!-- <el-button type="primary" class="fillReport">填写季报</el-button> -->
    <div class="notify">
      <p>
        <i class="el-icon-warning-outline"></i>
        说明事项：
      </p>
      <p>1、入驻机构于每季度结束后7个工作日之内报送季度信息，每季度初始信息直接引用上季度数据，机构直接更新即可。</p>
      <p>2、若已填报《湖南辖区私募基金管理人季度报表》，无需重复填报，直接上传《湖南辖区私募基金管理人季度报表》</p>
    </div>
    <div class="search_report">
      <span>企业名称</span>
      <el-select v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.institutionName"
          :value="item.institutionCode"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="search" class="borderBtn">搜索</el-button>
      <el-button @click="repeit" class="borderBtn">重置</el-button>
    </div>
    <record-table :tableData="tableData" :type="type" @changeReportFill="getList"></record-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import RecordTable from './components/recordTable'
import { initReport, getReportList, repeitName } from 'common/js/api'
import { mapMutations } from 'vuex'

export default {
  components: {
    RecordTable
  },

  data() {
    return {
      tableData: [],
      userCode: '', //JG409990 //JG142501
      type: '',
      total: 0,
      currentPage: 1,
      pageSize: 5,
      options: [],
      value: ''
    }
  },

  mounted() {
    this.userCode = this.Cookies.get('identifyCode')
    this.getList()
    this.getOptions()
  },

  methods: {
    search() {
      this.getList()
    },
    repeit() {
      this.value = ''
      this.getList()
    },
    async getList() {
      const isOk = await this.initRecord()
      if (!isOk) return
      const params = {
        identifyCode: this.userCode,
        institutionCode: this.value,
        page: this.currentPage,
        size: this.pageSize
      }
      this.changeLoadingstate(true)
      const { result } = await getReportList(params)
      this.tableData = result.list
      this.tableData.map(item => {
        if (item.submitTime === null) {
          item.submitTime = ''
        }
        return item
      })
      this.total = result.total
      this.currentPage = result.pageNum
      this.pageSize = result.pageSize
    },

    async initRecord() {
      return true
      const res = await initReport(this.userCode)
      this.type = res.result.institutionType
      if (res.result.info == 'NOT ENTERY') {
        const message = res.result.institutionType == 'GL' ? '管理' : ''
        this.$message.error(`请先入驻基金${message}机构,再填写季报`)
        return false
      } else return true
    },

    async getOptions() {
      let { result } = await repeitName(this.Cookies.get('identifyCode'))
      this.options = result
    },

    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },

    ...mapMutations(['changeLoadingstate'])
  }
}
</script>

<style scoped>
.reportRecord {
  position: relative;
  height: 100%;
}

.fillReport {
  position: absolute;
  top: -60px;
  right: 0px;
  background: #3165ff !important;
  border-radius: 2px !important;
}
.notify {
  padding: 20px;
  background: #f5f8ff;
  border: 1px solid #baccff;
  box-shadow: 0 1px 0 0 #f6f3f3;
  border-radius: 2px;
}
.notify p {
  font-size: 14px;
  color: #0000377a;
  margin-bottom: 5px;
}
.search_report {
  padding: 20px 0;
}
.search_report span {
  padding-right: 10px;
  color: #ccc;
}
.search_report >>> .el-select {
  padding-right: 10px;
}
.search_report >>> .el-button {
  /* border-color: #3165ff !important; */
  /* color: #3165ff; */
}
</style>
<style lang="scss" scoped>
.reportRecord {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #cccccc80;
  height: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
  padding: 20px;
  > .table {
    flex: 1;
  }
}
.search_report {
  ::v-deep .el-input__inner {
    height: 28px;
  }
}
</style>
